<div
  *ngIf="((locales$ | async)?.length ?? 0) > 1"
  class="flex justify-between px-5 py-3"
>
  <div></div>
  <app-select-language-block></app-select-language-block>
</div>
